import { API_ROOT_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';
import type { RiskMapResponse, TasksResponse } from './types';

export async function fetchRiskMapData(): Promise<RiskMapResponse> {
  return apiFetch<RiskMapResponse>(
    '/api/risk-analysis/risk-landscape/map?filter=%7B%22scope%22%3A%22network%22%7D',
    {},
    API_ROOT_URL,
  );
}

export async function fetchTasks(): Promise<TasksResponse> {
  return apiFetch<TasksResponse>(
    '/api/notifications?page=0&count=50&notificationTriggerType=actionable&status=pending&filter=%7B%7D&sort=updatedAt%3ADESC',
    {},
    API_ROOT_URL,
  );
}

export async function updateTaskStatus(
  id: string,
  newStatus: string,
): Promise<void> {
  return apiFetch(
    `/api/notifications/${id}`,
    {
      method: 'PATCH',
      body: JSON.stringify({ status: newStatus }),
    },
    API_ROOT_URL,
  );
}
